<template>
  <div
    id="advantage"
    class="advantage-container"
  >
    <div class="advantage-part-wrapper content-part-wrapper">
      <div class="advantage-title-wrapper content-title-wrapper">
        <h3>{{ $t('ADVANTAGE') }}</h3>
        <span class="title-line"></span>
      </div>
      <div class="pc-advantage-wrapper">
        <ul class="pc-icon-wrapper">
          <li
            v-for="(item, index) in advantage"
            class="pc-icon"
            :index="index"
          >
            <img
              :normal-src="item.iconlink"
              :active-src="item.activelink"
              :src="item.iconlink"
            >
          </li>
        </ul>
      </div>
      <div class="advantage-wrapper">
        <section class="regular slider">
          <div
            v-for="item in advantage"
            class="slide-item"
          >
            <img :src="item.iconlink">
            <div class="content-wrapper">
              <p class="title">{{item.title}}</p>
              <p class="introduction">{{item.introduction}}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "ADVANTAGE": "ADVANTAGE"
  },
  "zn": {
    "ADVANTAGE": "核心优势"
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "BannerContainer",
  props: {},
  data() {
    return {
      // advantage: [],
      advantageEn: [
        {
          iconlink: require("../../assets/pageadvantage/1.png"),
          activelink: require("../../assets/pageadvantage/1_active.png"),
          title: "Wide user coverage",
          introduction:
            "users can join networks with various devices more flexibly."
        },
        {
          iconlink: require("../../assets/pageadvantage/2.png"),
          activelink: require("../../assets/pageadvantage/2_active.png"),
          title: "Cloud computing experience",
          introduction:
            "10 years of experience in cloud computing, independently completed R & D of cloud computing platform including virtualization,resource scheduling, SDN networks and cloud storage, etc. Experience of operating more than 500 thousand servers."
        },
        {
          iconlink: require("../../assets/pageadvantage/3.png"),
          activelink: require("../../assets/pageadvantage/3_active.png"),
          title: "Cross platform R & D experience",
          introduction:
            "software and hardware R & D experience on platforms like X86, ARM, GPU and FPGA."
        },
        {
          iconlink: require("../../assets/pageadvantage/4.png"),
          activelink: require("../../assets/pageadvantage/4_active.png"),
          title: "All-around team",
          introduction:
            "cloud computing company team with years of tacit cooperation in R & D, operation, marketing,BD,and sales, etc. Years of experience in Blockchain industry and network security."
        },
        {
          iconlink: require("../../assets/pageadvantage/5.png"),
          activelink: require("../../assets/pageadvantage/5_active.png"),
          title: "Customer resources",
          introduction:
            "core members of the team have served as head of sales in large IT companies such as Alibaba and CISCO. Lots of customer resources at Top 500 Global Corporations."
        }
      ],
      advantageZn: [
        {
          iconlink: require("../../assets/pageadvantage/1.png"),
          activelink: require("../../assets/pageadvantage/1_active.png"),
          title: "用户覆盖广",
          introduction: "用户可以更灵活的以各种设备加入网络。"
        },
        {
          iconlink: require("../../assets/pageadvantage/2.png"),
          activelink: require("../../assets/pageadvantage/2_active.png"),
          title: "云计算经验",
          introduction: "10年云计算技术经验，自主研发完成过包括虚拟化，资源调度，SDN网络，云存储等领域在内的云计算平台，拥有运维超过50万台服务器的经验。"
        },
        {
          iconlink: require("../../assets/pageadvantage/3.png"),
          activelink: require("../../assets/pageadvantage/3_active.png"),
          title: "跨平台研发经验",
          introduction: "X86，ARM，GPU，FPGA多种平台的软件和硬件开发经验。"
        },
        {
          iconlink: require("../../assets/pageadvantage/4.png"),
          activelink: require("../../assets/pageadvantage/4_active.png"),
          title: "全能团队",
          introduction: "默契配合多年的云计算公司团队，覆盖研发、运维、市场、BD、销售等各个环节，并拥有多年区块链行业经验及网络安全经验。"
        },
        {
          iconlink: require("../../assets/pageadvantage/5.png"),
          activelink: require("../../assets/pageadvantage/5_active.png"),
          title: "客户资源",
          introduction: "团队核心成员曾担任阿里巴巴、思科等大型IT公司销售负责人，拥有大量500强客户资源。"
        }
      ]
    };
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    advantage() {
      if (this.isZnWebsite) {
        return this.advantageZn;
      } else {
        return this.advantageEn;
      }
      return this.advantageEn;
    }
  }),
  created() {
    // this.$i18n.locale = language;
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";

    // if (this.isZnWebsite) {
    //   this.advantage = this.advantageZn;
    // } else {
    //   this.advantage = this.advantageEn;
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.advantage-part-wrapper {
  margin: 50px 0 150px;

  .advantage-title-wrapper.content-title-wrapper {
    margin-bottom: 120px;
  }

  .pc-advantage-wrapper {
    margin: 0 auto;
    width: 70%;
  }

  .pc-icon-wrapper {
    // margin-bottom: 80px;
    padding: 0 10%;
    display: flex;
    // width: 70%;
    margin: 0 auto 80px;
    justify-content: center;
    align-items: center;

    .pc-icon {
      width: 16%;
      display: inline-block;
      padding: 0 2%;
      box-sizing: border-box;
      max-width: 165px;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .slider {
    width: 50%;
    margin-left: 20%;
  }

  .slick-slide {
    img {
      display: none;
    }

    .title {
      font-size: 18px;
      margin-bottom: 18px;
    }

    .introduction {
      font-size: 12px;
    }
  }

  .slick-dots {
    display: none;

    li button {
      &:before {
        display: none !important;
      }
    }
  }

  .advantage-dots {
    text-align: left;
    bottom: -30px;

    li {
      margin: 0;
      margin-left: -5px;
      margin-right: 2px;
      color: #fff;

      button {
        color: #fff;

        &:before {
          display: inline-block !important;
          color: #fff;
          opacity: 0.4;
        }
      }

      &.slick-active button:before {
        color: #fff;
        opacity: 0.9;
      }
    }
  }

  .advantage-wrapper {
    width: 70%;
    margin: 0 auto;
  }
}

@media (max-width: 720px) {
  .advantage-part-wrapper {
    margin: 50px 0 100px;

    .pc-advantage-wrapper {
      display: none;
    }

    .advantage-title-wrapper.content-title-wrapper {
      margin-bottom: 50px;
    }

    .slider {
      width: 100%;
      margin: 0;
    }

    .slick-slide {
      img {
        display: block;
        width: 35%;
        margin-bottom: 40px;
        -webkit-filter: grayscale(30%);
        filter: grayscale(30%);
      }
    }

    .advantage-dots {
      text-align: left;
      bottom: -30px;

      li {
        margin: 0;
        margin-left: -5px;
        margin-right: 2px;
        color: #fff;

        button {
          color: #fff;

          &:before {
            display: inline-block !important;
            color: #fff;
            opacity: 0.4;
          }
        }

        &.slick-active button:before {
          color: #fff;
          opacity: 0.9;
        }
      }
    }
  }
}
</style>
